import { render, staticRenderFns } from "./RosterGroup.vue?vue&type=template&id=89ec55d6&scoped=true"
import script from "./RosterGroup.vue?vue&type=script&lang=js"
export * from "./RosterGroup.vue?vue&type=script&lang=js"
import style0 from "./RosterGroup.vue?vue&type=style&index=0&id=89ec55d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ec55d6",
  null
  
)

export default component.exports